<template>
  <dialog-v2
    :show="show"
    :title="dialogTitle"
    :disable-save-btn="disabled"
    :loading="loading"
    save-button-text="Iniciar"
    max-width="400px"
    @close="closeDialog"
    @save="saveDialog">
    <div slot="title">
      <v-btn
        v-if="!newInfra"
        class="tiny-btn"
        :class="{
          'active': form.call_type === 'softphone',
          'tex-success': form.call_type === 'softphone',
        }"
        depressed
        small
        @click="form.call_type = 'softphone'">
        Microsip
        <v-icon
          v-if="form.call_type === 'softphone'"
          color="success"
          class="ml-2"
          small>fas fa-check-circle</v-icon>
      </v-btn>
    </div>
    <template slot="content">
      <v-layout mb-3>
        <v-flex md12>
          <small>Campaña a conectar</small>
          <h3>{{ callList.name }}</h3>
          <small>{{ callList.descrip }}</small>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="!newInfra">
        <!-- <v-flex>
          <v-switch
          label="Recibir llamadas entrantes"
          v-model="form.receive_incoming_calls"
          class="k-blue-linear-text"
          :hide-details="true"/>
        </v-flex> -->
      </v-layout>
      <v-layout row wrap v-if="form.call_type === 'softphone'">
        <v-flex>
          <v-text-field
            v-model="form.extension_number"
            v-validate="'required'"
            data-vv-name="extension_number"
            data-vv-scope="callCenterStart"
            data-vv-as="extension"
            color="black"
            label="Extension"
            :error-messages="errors.collect('callCenterStart.extension_number')"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import DialogV2 from '@/components/global/DialogV2';
import callListMixin from '@/mixins/callList';

export default {
  inject: ['$validator'],
  props: {
    callList: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    newInfra: {
      type: Boolean,
      default: false,
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DialogV2,
  },
  mixins: [
    callListMixin,
  ],
  data() {
    const emptyForm = {
      call_type: '',
      zoom_url: '',
      conference_id: '',
      access_code: '',
      extension_number: '',
      receive_incoming_calls: true,
      new_server: false,
    };
    return {
      emptyForm,
      form: _.cloneDeep(emptyForm),
    };
  },
  computed: {
    ...mapGetters({
      loading: 'dialerV2/loading',
    }),
    dialogTitle() {
      return 'Iniciar call center';
    },
    disabled() {
      return this.disableSaveBtn || this.loading || (!this.newInfra && !this.form.call_type);
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.form = _.cloneDeep(this.emptyForm);
      }, 300);
    },
    saveDialog() {
      this.$validator.validateAll('callCenterStart')
        .then((validation) => {
          if (validation) {
            this.$store.commit('dialerV2/SET_LOADING', true);
            this.$emit('save', this.form);
          }
        });
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.$store.commit('dialerV2/SET_LOADING', false);
        this.form = {
          call_type: '',
          zoom_url: '',
          conference_id: '',
          access_code: '',
          extension_number: '',
          receive_incoming_calls: true,
          new_server: false,
        };
      }
    },
    'form.call_type'() {
      if (this.form.call_type !== 'softphone') {
        this.form.new_server = false;
      }
    },
    newInfra: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.form.call_type = 'softphone';
        } else {
          this.form.call_type = '';
        }
      },
    },
  },
};
</script>

<style scoped>
.call-type-btn {
  height: 200px !important;
  border: 1px solid #000;
  border-radius: 5px;
  color: rgba(128, 128, 128, 0.72);
  position: relative;
}
.call-type-btn i {
  position: absolute;
  top: 10px;
  right: 10px;
}
.tiny-btn {
  border: 1px solid #eee;
}
.tiny-btn.active {
  color: #4caf50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/Detail/ModalV2.vue